import { AbilityBuilder, createMongoAbility } from '@casl/ability'

const { can, cannot, build } = new AbilityBuilder(createMongoAbility);
can('do', 'nothing');

let ability = build();

export default ability
